import { Box, CircularProgress, Paper, Stack, Typography } from "@mui/material";
import { DownloadIcon } from "../../../../../../../components/icons/DownloadIcon";
import { PdfIcon } from "../../../../../../../components/icons/PdfIcon";
import { PrintIcon } from "../../../../../../../components/icons/PrintIcon";
import { ShareIcon } from "../../../../../../../components/icons/ShareIcon";
import { useState } from "react";
import SendProposalModal from "./SendProposalModal";

interface PdfHeaderProps {
  onPrint?: () => void;
  onShare?: () => void;
  onDownload?: () => void;
  bookingType?: string;
  isSending?: boolean;
}

export default function PdfHeader({
  onPrint,
  onShare,
  onDownload,
  bookingType,
  isSending = false,
}: PdfHeaderProps) {
  const [sendModalOpen, setSendModalOpen] = useState(false);

  const title =
    bookingType === "Conference"
      ? "Conference Proposal"
      : "Funeral Stream Proposal";

  const handleSend = () => {
    setSendModalOpen(false);
    onShare?.();
  };

  return (
    <>
      <Paper sx={{ borderRadius: 3, p: 2, boxShadow: 0, mb: 2 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: "8px",
                bgcolor: "#fee2e2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PdfIcon fontSize="large" sx={{ color: "#EF5350" }} />
            </Box>
            <Box>
              <Typography
                sx={{ fontWeight: 700, fontSize: "16px", color: "#1e293b" }}
              >
                Client View(PDF)
              </Typography>
              <Typography sx={{ fontSize: "14px", color: "#94a3b8" }}>
                {title}
              </Typography>
            </Box>
          </Stack>

          <Stack direction="row" spacing={1.5}>
            {[
              {
                icon: <PrintIcon sx={{ color: "#724e41", fontSize: 28 }} />,
                onClick: onPrint,
              },
              {
                icon: isSending
                  ? <CircularProgress size={18} sx={{ color: "#724e41" }} />
                  : <ShareIcon sx={{ color: "#724e41", fontSize: 28 }} />,
                onClick: isSending ? undefined : () => setSendModalOpen(true),
              },
              {
                icon: <DownloadIcon sx={{ color: "#724e41", fontSize: 28 }} />,
                onClick: onDownload,
              },
            ].map((action, i) => (
              <Box
                key={i}
                onClick={action.onClick}
                sx={{
                  width: 34,
                  height: 34,
                  borderRadius: "8px",
                  bgcolor: "transparent",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.15s",
                  "&:hover": { bgcolor: "#f0f4f8", color: "#724e41" },
                }}
              >
                {action.icon}
              </Box>
            ))}
          </Stack>
        </Stack>
      </Paper>

      <SendProposalModal
        open={sendModalOpen}
        onClose={() => setSendModalOpen(false)}
        onSend={handleSend}
      />
    </>
  );
}